/* ============================================================
   SK Single Meals — filter · sort · load-more · quick-add.
   Filtering/sorting is client-side over the rendered grid
   (data-goal/data-diet/data-protein/...). Quick-add talks to the
   REAL Shopify cart (cart/add + cart/change), keeps the in-card
   steppers + running-total bag pill in sync, and dispatches
   'sk-cart:refresh' so the sk-cart drawer/header update too.
   Adds do NOT auto-open the drawer (smooth multi-meal adding —
   matches the snacks page); the pill's button opens it.
   ============================================================ */
(function () {
  "use strict";

  var root = document.querySelector("[data-sk-single-meals]");
  if (!root) return;

  var $  = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };

  /* ── config + initial cart ── */
  function readJSON(sel, fallback) {
    var n = $(sel); if (!n) return fallback;
    try { return JSON.parse(n.textContent); } catch (e) { return fallback; }
  }
  var cfg = readJSON("[data-sm-config]", { initialCount: 12, moneySymbol: "$", cartCount: 0, cartTotal: 0, routes: {}, progress: {} });
  cfg.progress = cfg.progress || {};
  var bag = readJSON("[data-sm-cart]", {}) || {}; // { variantId: qty }

  var state = { goals: new Set(), diets: new Set(), sort: "featured", revealed: false, cartCount: cfg.cartCount || 0, cartTotal: cfg.cartTotal || 0 };

  var cards    = $$(".sk-sm-card");
  var chips    = $$(".sk-sm-chip");
  var sortSel  = $("[data-sm-sort]");
  var activeRow = $("[data-sm-active]");
  var countEl  = $("[data-sm-count]");
  var labelEl  = $("[data-sm-label]");
  var emptyEl  = $("[data-sm-empty]");
  var loadMore = $("[data-sm-loadmore]");
  var toolbar  = $("[data-sm-toolbar]");
  var grid     = $("[data-sm-grid]");
  var bagbar   = $("[data-sm-bagbar]");
  var bagCount = $("[data-sm-bag-count]");
  var bagTotal = $("[data-sm-bag-total]");
  var progEl   = $("[data-sm-progress]");
  var progFill = $("[data-sm-progress-fill]");
  var progMsg  = $("[data-sm-progress-msg]");
  var TOTAL = cards.length;

  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    var r = Math.round(n * 100) / 100;
    return (cfg.moneySymbol || "$") + (Number.isInteger(r) ? r : r.toFixed(2));
  }
  function jsUrl(route, fallback) {
    var base = route || fallback;
    return base.indexOf(".js") === -1 ? base + ".js" : base;
  }

  /* ============================================================
     Filter + sort + load-more
     ============================================================ */
  function matches(card) {
    if (state.goals.size && !state.goals.has(card.getAttribute("data-goal"))) return false;
    if (state.diets.size) {
      var tags = (card.getAttribute("data-diet") || "").split(" ");
      var ok = true;
      state.diets.forEach(function (d) { if (tags.indexOf(d) === -1) ok = false; });
      if (!ok) return false;
    }
    return true;
  }
  function sortVal(card, key) {
    var attr = { protein: "data-protein", cal: "data-cal", price: "data-price", newest: "data-new" }[key];
    var n = parseFloat(card.getAttribute(attr));
    return isNaN(n) ? null : n;
  }
  function applySort() {
    var key = state.sort;
    if (key === "featured") { cards.forEach(function (c) { c.style.order = ""; }); return; }
    var dir = (key === "protein" || key === "newest") ? -1 : 1;
    cards.slice().sort(function (a, b) {
      var va = sortVal(a, key), vb = sortVal(b, key);
      if (va === null && vb === null) return 0;
      if (va === null) return 1;   // missing macro data always sinks to the end
      if (vb === null) return -1;
      return dir * (va - vb);
    }).forEach(function (c, i) { c.style.order = i; });
  }

  var LABELS = {};
  chips.forEach(function (c) { LABELS[c.getAttribute("data-val")] = c.textContent.trim(); });

  function render() {
    var filtering = state.goals.size > 0 || state.diets.size > 0;
    var showAll = state.revealed || filtering || state.sort !== "featured";

    var matched = 0, hiddenMatches = 0;
    cards.forEach(function (card) {
      var ok = matches(card);
      if (ok) matched++;
      var visible = ok && (showAll || card.getAttribute("data-batch") === "1");
      if (ok && !visible) hiddenMatches++;
      card.classList.toggle("is-hidden", !visible);
    });

    if (countEl) countEl.textContent = filtering ? (matched + " of " + TOTAL) : TOTAL;
    if (labelEl) labelEl.textContent = matched === 1 ? "meal" : "meals";
    if (emptyEl) emptyEl.classList.toggle("is-show", matched === 0);

    if (loadMore) {
      if (hiddenMatches > 0) {
        loadMore.hidden = false;
        loadMore.textContent = "Load " + hiddenMatches + " more meal" + (hiddenMatches === 1 ? "" : "s");
      } else {
        loadMore.hidden = true;
      }
    }

    renderActive();
  }

  function renderActive() {
    if (!activeRow) return;
    var active = Array.from(state.goals).concat(Array.from(state.diets));
    activeRow.hidden = active.length === 0;
    activeRow.innerHTML = "";
    if (!active.length) return;
    var lbl = document.createElement("span");
    lbl.className = "sk-sm-aflabel";
    lbl.textContent = "Filtering by";
    activeRow.appendChild(lbl);
    active.forEach(function (v) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "sk-sm-afchip";
      b.innerHTML = (LABELS[v] || v) + ' <span class="x" aria-hidden="true">×</span>';
      b.setAttribute("aria-label", "Remove " + (LABELS[v] || v) + " filter");
      b.addEventListener("click", function () { toggleFilter(v); });
      activeRow.appendChild(b);
    });
    var clear = document.createElement("button");
    clear.type = "button";
    clear.className = "sk-sm-clear";
    clear.textContent = "Clear all";
    clear.addEventListener("click", clearAll);
    activeRow.appendChild(clear);
  }

  function toggleFilter(val) {
    var chip = chips.filter(function (c) { return c.getAttribute("data-val") === val; })[0];
    if (!chip) return;
    var set = chip.getAttribute("data-group") === "goal" ? state.goals : state.diets;
    if (set.has(val)) set.delete(val); else set.add(val);
    chip.classList.toggle("is-on", set.has(val));
    render();
  }
  function clearAll() {
    state.goals.clear(); state.diets.clear();
    chips.forEach(function (c) { c.classList.remove("is-on"); });
    render();
  }

  chips.forEach(function (chip) {
    chip.addEventListener("click", function () { toggleFilter(chip.getAttribute("data-val")); });
  });
  var emptyClear = $("[data-sm-empty-clear]");
  if (emptyClear) emptyClear.addEventListener("click", clearAll);
  if (sortSel) sortSel.addEventListener("change", function () { state.sort = sortSel.value; applySort(); render(); });
  if (loadMore) loadMore.addEventListener("click", function () { state.revealed = true; render(); });

  /* sticky toolbar shadow */
  if (toolbar && toolbar.parentNode) {
    var sentinel = document.createElement("div");
    toolbar.parentNode.insertBefore(sentinel, toolbar);
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (e) {
        toolbar.classList.toggle("is-stuck", !e[0].isIntersecting);
      }, { threshold: 0 }).observe(sentinel);
    }
  }

  /* ============================================================
     Quick-add → real cart
     ============================================================ */
  function renderBag(doBump) {
    cards.forEach(function (card) {
      if (card.hasAttribute("data-multi")) {
        /* segmented goal card: the active segment's variant drives the single Add/stepper */
        var mbuy = card.querySelector("[data-sm-multi-buy]");
        var activeVid = mbuy ? mbuy.getAttribute("data-active") : null;
        var inBag = 0;
        $$("[data-goal-seg]", card).forEach(function (seg) {
          var sq = bag[seg.getAttribute("data-variant")] || 0;
          inBag += sq;
          seg.classList.toggle("has-qty", sq > 0);
        });
        var aq = bag[activeVid] || 0;
        var madd = card.querySelector("[data-sm-multi-add]");
        var mstep = card.querySelector("[data-sm-multi-step]");
        if (madd) madd.hidden = aq > 0;
        if (mstep) {
          mstep.hidden = aq === 0;
          var mq = mstep.querySelector(".sk-sm-qty");
          if (mq) mq.textContent = aq;
        }
        card.classList.toggle("has-in-bag", inBag > 0);
        return;
      }
      var vid = card.getAttribute("data-variant");
      if (!vid) return;
      var qty = bag[vid] || 0;
      var add = card.querySelector(".sk-sm-add");
      var stepper = card.querySelector(".sk-sm-stepper");
      if (add) add.hidden = qty > 0;
      if (stepper) {
        stepper.hidden = qty === 0;
        var q = stepper.querySelector(".sk-sm-qty");
        if (q) q.textContent = qty;
      }
    });
    if (bagbar) bagbar.classList.toggle("is-show", state.cartCount > 0);
    if (bagCount) bagCount.textContent = state.cartCount;
    if (bagTotal) bagTotal.textContent = state.cartCount > 0 ? "· " + money(state.cartTotal) : "";
    if (doBump && bagCount) {
      bagCount.classList.add("bump");
      setTimeout(function () { bagCount.classList.remove("bump"); }, 250);
    }
    renderProgress();
  }

  function renderProgress() {
    if (!progEl) return;
    var p = cfg.progress || {};
    var threshold = Number(p.threshold) || 0;
    if (!p.enabled || threshold <= 0 || state.cartCount === 0) {
      progEl.hidden = true;
      return;
    }
    progEl.hidden = false;
    var pct = Math.min(100, Math.round((state.cartTotal / threshold) * 100));
    if (progFill) progFill.style.transform = "scaleX(" + (pct / 100) + ")"; // transform, not width: no layout work per frame
    var remaining = threshold - state.cartTotal;
    if (remaining <= 0) {
      progEl.classList.add("is-done");
      if (progMsg) progMsg.textContent = p.unlocked || "Nice box!";
    } else {
      progEl.classList.remove("is-done");
      if (progMsg) progMsg.textContent = money(remaining) + " " + (p.toward || "to go");
    }
  }

  function syncFromCart(cart) {
    if (!cart || typeof cart.item_count !== "number") return;
    state.cartCount = cart.item_count;
    state.cartTotal = cart.total_price;
    var fresh = {};
    (cart.items || []).forEach(function (it) { fresh[it.variant_id] = (fresh[it.variant_id] || 0) + it.quantity; });
    bag = fresh;
  }
  /* When WE change the cart we broadcast sk-cart:refresh for the drawer/header.
     A flag lets our own listener ignore that self-broadcast (dispatchEvent is
     synchronous, so the flag is still true while the listener runs) — that's
     what prevents the refresh→notify→refresh loop the old stub guarded against. */
  var selfDispatch = false;
  function notifyDrawer() {
    selfDispatch = true;
    document.dispatchEvent(new CustomEvent("sk-cart:refresh"));
    selfDispatch = false;
  }

  function postJSON(url, body) {
    return fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  function refreshFromServer(doBump) {
    return fetch(jsUrl(cfg.routes.cart, "/cart"), { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { syncFromCart(cart); renderBag(doBump); notifyDrawer(); })
      .catch(function () {});
  }

  function changeVariant(vid, price, delta) {
    if (!vid) return;
    price = price || 0;
    var cur = bag[vid] || 0;
    var next = Math.max(0, cur + delta);

    /* optimistic: update UI instantly, reconcile from the server response */
    if (next === 0) delete bag[vid]; else bag[vid] = next;
    state.cartCount = Math.max(0, state.cartCount + (next - cur));
    state.cartTotal = Math.max(0, state.cartTotal + (next - cur) * price);
    renderBag(true);

    if (cur === 0 && next === 1) {
      postJSON(jsUrl(cfg.routes.cartAdd, "/cart/add"), { id: Number(vid), quantity: 1 })
        .then(function () { return refreshFromServer(false); })
        .catch(function () { refreshFromServer(false); });
    } else {
      postJSON(jsUrl(cfg.routes.cartChange, "/cart/change"), { id: Number(vid), quantity: next })
        .then(function (cart) { syncFromCart(cart); renderBag(false); notifyDrawer(); })
        .catch(function () { refreshFromServer(false); });
    }
  }
  function bumpCard(card, delta) {
    if (!card) return;
    changeVariant(card.getAttribute("data-variant"), parseFloat(card.getAttribute("data-price")) || 0, delta);
  }
  function rowDelta(row, delta) {
    if (!row) return;
    changeVariant(row.getAttribute("data-variant"), parseFloat(row.getAttribute("data-price")) || 0, delta);
  }

  /* point a card's product links at a specific variant so the PDP opens with it
     pre-selected (Shopify resolves ?variant=<id> → selected_or_first_available_variant) */
  function linkCardToVariant(card, vid) {
    if (!card || !vid) return;
    $$("a[href]", card).forEach(function (a) {
      var base = (a.getAttribute("href") || "").split("?")[0];
      if (!base) return;
      a.setAttribute("href", base + "?variant=" + vid);
    });
  }

  /* inline segmented goal pill: pick a goal → it becomes the card's active variant */
  function selectGoal(seg) {
    if (!seg || seg.hasAttribute("disabled")) return;
    var card = seg.closest(".sk-sm-card");
    var buy = card && card.querySelector("[data-sm-multi-buy]");
    if (!buy) return;
    var vid = seg.getAttribute("data-variant");
    $$("[data-goal-seg]", card).forEach(function (s) { s.setAttribute("aria-pressed", s === seg ? "true" : "false"); });
    buy.setAttribute("data-active", vid);
    buy.setAttribute("data-active-goal", seg.getAttribute("data-t") || "");
    var priceEl = card.querySelector("[data-sm-active-price]");
    if (priceEl) priceEl.textContent = money(parseFloat(seg.getAttribute("data-price")) || 0);
    updateRing(card, seg);
    linkCardToVariant(card, vid);
    renderBag(false);
  }

  /* macro ring overlaid on the photo — arcs sweep + kcal/legend + tier palette follow the
     chosen tier. Same SVG-arc donut maths as the meal PDP "this week's" panel (r=21,
     C≈131.946, 5px gaps); the per-tier recolour rides [data-tier] on the macrobar, the
     home-page / Weekly Box mechanism. */
  var RING_R = 21, RING_C = 2 * Math.PI * RING_R, RING_GAP = 5, RING_USABLE = RING_C - RING_GAP * 3;
  function legTxt(v) { return (v === null || v === "" || v === "undefined") ? "—" : Math.round(parseFloat(v)) + "g"; }
  function updateRing(card, seg) {
    var ring = card.querySelector("[data-sm-ring]");
    if (!ring || !seg) return;
    var p = parseFloat(seg.getAttribute("data-p")) || 0;
    var c = parseFloat(seg.getAttribute("data-c")) || 0;
    var f = parseFloat(seg.getAttribute("data-f")) || 0;
    var kp = p * 4, kc = c * 4, kf = f * 9, tot = kp + kc + kf;
    if (tot > 0) {
      var arcs = [["p", kp / tot], ["c", kc / tot], ["f", kf / tot]], cur = 0;
      arcs.forEach(function (a) {
        var el = ring.querySelector('[data-sm-arc="' + a[0] + '"]');
        var len = Math.max(RING_USABLE * a[1], 0.5);
        if (el) { el.style.strokeDasharray = len + " " + (RING_C - len); el.style.strokeDashoffset = String(-cur); }
        cur += len + RING_GAP;
      });
    }
    var cal = seg.getAttribute("data-cal");
    var calEl = card.querySelector("[data-sm-ring-cal]");
    if (calEl && cal) { calEl.textContent = cal; }
    var legP = card.querySelector("[data-sm-leg-p]"); if (legP) legP.textContent = legTxt(seg.getAttribute("data-p"));
    var legC = card.querySelector("[data-sm-leg-c]"); if (legC) legC.textContent = legTxt(seg.getAttribute("data-c"));
    var legF = card.querySelector("[data-sm-leg-f]"); if (legF) legF.textContent = legTxt(seg.getAttribute("data-f"));
    /* recolour ring + legend to the tier (green → orange → red) */
    var bar = card.querySelector(".sk-sm-macrobar");
    var tier = seg.getAttribute("data-t");
    if (bar && tier) bar.setAttribute("data-tier", tier);
    /* brief pop on the kcal number so the change reads even when arcs barely move */
    ring.classList.remove("is-upd");
    void ring.offsetWidth;
    ring.classList.add("is-upd");
  }
  function multiActive(card) {
    var buy = card && card.querySelector("[data-sm-multi-buy]");
    var vid = buy ? buy.getAttribute("data-active") : null;
    var seg = vid && card.querySelector('[data-goal-seg][data-variant="' + vid + '"]');
    return { vid: vid, price: seg ? (parseFloat(seg.getAttribute("data-price")) || 0) : 0 };
  }

  /* popover open/close (one open at a time) */
  function closePops(except) {
    $$("[data-sm-choosewrap].is-open").forEach(function (w) {
      if (w === except) return;
      w.classList.remove("is-open");
      var btn = w.querySelector("[data-sm-choose]");
      if (btn) btn.setAttribute("aria-expanded", "false");
      var pop = w.querySelector("[data-sm-pop]");
      if (pop) pop.hidden = true;
    });
  }
  function openPop(wrap) {
    var pop = wrap.querySelector("[data-sm-pop]");
    var btn = wrap.querySelector("[data-sm-choose]");
    var isOpen = wrap.classList.contains("is-open");
    closePops(wrap);
    if (isOpen) { wrap.classList.remove("is-open"); if (pop) pop.hidden = true; if (btn) btn.setAttribute("aria-expanded", "false"); return; }
    wrap.classList.add("is-open");
    if (pop) pop.hidden = false;
    if (btn) btn.setAttribute("aria-expanded", "true");
  }

  if (grid) {
    grid.addEventListener("click", function (e) {
      /* inline segmented goal pill: choose a goal */
      var seg = e.target.closest("[data-goal-seg]");
      if (seg) { e.preventDefault(); selectGoal(seg); return; }
      /* multi card: add / step the active goal variant (checked BEFORE generic .sk-sm-add) */
      var mAdd = e.target.closest("[data-sm-multi-add]");
      if (mAdd) { e.preventDefault(); var ai = multiActive(mAdd.closest(".sk-sm-card")); changeVariant(ai.vid, ai.price, 1); return; }
      var mStep = e.target.closest("[data-sm-multi-step]");
      if (mStep) {
        var mc = mStep.closest(".sk-sm-card"), mi = multiActive(mc);
        if (e.target.closest(".sk-sm-inc")) { changeVariant(mi.vid, mi.price, 1); return; }
        if (e.target.closest(".sk-sm-dec")) { changeVariant(mi.vid, mi.price, -1); return; }
        return;
      }

      /* single-variant cards */
      var add = e.target.closest(".sk-sm-add");
      if (add) { e.preventDefault(); bumpCard(add.closest(".sk-sm-card"), 1); return; }

      /* goal-tier popover: open/close */
      var chooseBtn = e.target.closest("[data-sm-choose]");
      if (chooseBtn) { e.preventDefault(); openPop(chooseBtn.closest("[data-sm-choosewrap]")); return; }
      var closeBtn = e.target.closest("[data-sm-pop-close]");
      if (closeBtn) { closePops(); return; }

      /* popover row add/stepper (per-variant) */
      var popAdd = e.target.closest(".sk-sm-pop-add");
      if (popAdd) { e.preventDefault(); rowDelta(popAdd.closest("[data-pop-row]"), 1); return; }
      var popInc = e.target.closest(".sk-sm-pop-step .sk-sm-inc");
      if (popInc) { rowDelta(popInc.closest("[data-pop-row]"), 1); return; }
      var popDec = e.target.closest(".sk-sm-pop-step .sk-sm-dec");
      if (popDec) { rowDelta(popDec.closest("[data-pop-row]"), -1); return; }

      /* single-variant card stepper (no [data-pop-row] ancestor) */
      var inc = e.target.closest(".sk-sm-inc");
      if (inc) { bumpCard(inc.closest(".sk-sm-card"), 1); return; }
      var dec = e.target.closest(".sk-sm-dec");
      if (dec) { bumpCard(dec.closest(".sk-sm-card"), -1); return; }
    });
  }

  /* close popovers on outside click / Escape */
  document.addEventListener("click", function (e) {
    if (!e.target.closest("[data-sm-choosewrap]")) closePops();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closePops();
  });

  /* keep the pill/steppers fresh if the cart changes elsewhere (drawer remove /
     qty step, a PDP add, the header). Skip our own broadcasts (selfDispatch) and
     don't re-notify, so there's no loop. */
  function pullQuiet() {
    return fetch(jsUrl(cfg.routes.cart, "/cart"), { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { syncFromCart(cart); renderBag(true); })
      .catch(function () {});
  }
  document.addEventListener("sk-cart:refresh", function () { if (!selfDispatch) pullQuiet(); });
  document.addEventListener("sk-cart:added",   function () { if (!selfDispatch) pullQuiet(); });

  /* ── init ── */
  /* prime each segmented card's price + macros line from its default-selected goal */
  $$(".sk-sm-card[data-multi] [data-goal-seg][aria-pressed='true']").forEach(function (seg) { selectGoal(seg); });
  render();
  renderBag(false);
})();
